import { render } from "./vprintresourcesaddmore.vue?vue&type=template&id=6d4b8563&scoped=true"
import script from "./vprintresourcesaddmore.vue?vue&type=script&lang=js"
export * from "./vprintresourcesaddmore.vue?vue&type=script&lang=js"

import "./vprintresourcesaddmore.vue?vue&type=style&index=0&id=6d4b8563&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4b8563"]])

export default __exports__